import { useMemo } from 'react';
import { isStringEmpty } from '@shared/utils';
import WaitingWave from '../../waiting-wave';
import Markdown from '@/components/markdown';
import Anchor from '@/components/chat-history/Anchor';
import ActionBar from './ActionBar';
import Enhance from './enhance';
import EnhanceDs from './enhance-ds';

import { checkFEMessageId, getFixedRenewData, MessageType } from '@shared/store/chat';
import { HelperCore } from "@/common/helper";
import navbarStore from '@/store/navbar';
import wsStore from '../store';
import UserMessage from './UserMessage';
import globalStore from '@/store/global';

// const MD_URL_RE = /\[(\[[^]]*\]\([^)]*\))\]/gm;
const MD_URL_RE = /\[(\[[^\]]*?\]\([^\)]*?\))\]/gm;

function ListItem(props) {
  const store = wsStore.currentStore;

  const {
    index,
    msg_id,
    msg_type,
    loading = false,
    typing = false,
    role_id,
    prompt: question,
    page = [],
    txt,
    search_keyword = [],
    search_total,
    refer_search,
    result: answer = '',
    is_doing,
    compare_parent_id,
    role_biz,
  } = props;

  const isCompleted = is_doing == 0;

  const isSummaryPage =
    (typeof page === 'string' && page.length) ||
    (Array.isArray(page) && page.length > 0);

  const llmInfo = navbarStore.chatModels[role_id] || {};

  const text = useMemo(() => {
    if (isStringEmpty(answer)) {
      return answer;
    }

    return answer.replace(MD_URL_RE, (input, replaceValue) => {
      return isStringEmpty(replaceValue) ? input : replaceValue;
    });
  }, [answer]);

  const isDsModel = useMemo(() => {
    const dsLists = globalStore.cloudConfig?.assistantRobotOnlieSet;
    console.log(dsLists,dsLists.findIndex(item => item.robot_id === role_id) >= 0,1);
    if(!dsLists) return false
    return dsLists.findIndex(item => item.robot_id === role_id) >= 0
  }, [role_id]);

  /**
   * 显示搜索步骤
   * 1. 审核通过
   * 2. 有搜索词
   */
  const renderEnhancement = () => {
    if (
      (status != -1) &&
      (search_keyword?.length > 0 || refer_search?.length)
    ) {
      return (
        <div>
          <Enhance
            messageId={msg_id}
            messageItem={props}
            folded={true}
            isCompleted={isCompleted}
            chatStore={store}
            flows={{
              search_keyword,
              search_total,
              refer_search,
            }}
          />
        </div>
      );
    }

    return null;
  };

  if (msg_type === MessageType.ClearContext) {
    return (
      <li className="flex items-center" data-msgid={msg_id}>
        <span
          style={{
            background:
              'linear-gradient(270deg,rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 100%)',
          }}
          className="h-[1px] flex-1"
        ></span>
        <span className="px-[16px] text-[12px] text-[#bdbdbd]">
          已清除上下文
        </span>
        <span
          style={{
            background:
              'linear-gradient(270deg, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%)',
          }}
          className="h-[1px] flex-1"
        ></span>
      </li>
    );
  }

  return (
    <li className="flex flex-col gap-[24px]" data-msgid={msg_id}>
      <UserMessage {...props} />

      <section className="flex flex-col gap-[8px]">
        <div className="flex gap-[8px]">
          <img className="size-20px rounded-full" src={llmInfo.icon} />
          <strong className="text-[14px] font-medium leading-snug">
            {llmInfo.title}
          </strong>
        </div>
        {!isDsModel && renderEnhancement()}
        {isDsModel && msg_type !== MessageType.Welcome ? <EnhanceDs
          messageId={msg_id}
          messageItem={props}
          folded={false}
          chatStore={store}
        /> : null}
        {loading ? (
          isDsModel ? null: <WaitingWave color={globalStore.isDark ? "rgba(255,255,255,.2)" : "rgba(0,0,0,.2)"} /> 
        ) : (
          <div className="group flex flex-col gap-[16px]">
            <Markdown
              text={text}
              components={{
                a: props => (
                  <Anchor
                    {...props}
                    tooltipable={isCompleted}
                    references={refer_search}
                  />
                ),
              }}
            />
            <ActionBar
              className={[
                {
                  invisible: !isCompleted || index > 0,
                  'group-hover:visible': isCompleted && index > 0,
                },
              ]}
              renewable={index == 0}
              answer={answer}
              msg_id={msg_id}
              prompt={question}
              messageItem={store.messageMap.get(msg_id)}
              onRenew={() => {
                const messageItem = store.messageMap.get(msg_id);
                const { role_id, compare_parent_id } = messageItem;
                store.sendMessage({
                  renew: !checkFEMessageId(msg_id),
                  asstId: role_id,
                  messageId: msg_id,
                  input: question,
                  compare_parent_id,
                  ...getFixedRenewData(messageItem),
                });
              }}
            />
          </div>
        )}
      </section>
    </li>
  );
}

export default ListItem;
